<template>
  <!-- 听力筛查  -->
  <div v-if="model && model.hearing">
    <div id="print_hearing" class="page hearing-page" style="margin:0 auto; border:0px solid #E8E8EC;">
      <div style="height: 50px;"></div>
      <div style="font-size: 18px;"><span>{{ model.hearing.hospitalName ? model.hearing.hospitalName : "" }}</span></div>
      <div style="font-size: 22px;padding: 20px 0 30px 0;font-weight: 600;"><span>{{ model.hearing.reportName ? model.hearing.reportName : "听力筛查" }}</span></div>

      <table style="margin-top: 15px;text-align: left;border-bottom:1px solid rgb(14, 14, 14);width: 100%;border-collapse: collapse;">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">学校：<span>{{ model.hearing.schoolName ? model.hearing.schoolName : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">年级：<span>{{ model.hearing.gradeName ? model.hearing.gradeName : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">班级：<span>{{ model.hearing.className ? model.hearing.className : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">编号：<span>{{ model.hearing.barCode ? model.hearing.barCode : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;"></td>
            <td style="border-collapse: collapse;border:none;">筛查时间：<span>{{ model.hearing.physicalDate ? model.hearing.physicalDate : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="border-collapse: collapse;border:none;">姓名：<span>{{ model.hearing.name ? model.hearing.name : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">性别：<span>{{ model.hearing.sex ? model.hearing.sex : "" }}</span></td>
            <td style="border-collapse: collapse;border:none;">年龄：<span>{{ model.hearing.age ? model.hearing.age : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <div style="text-align:center;margin-top: 20px;border-bottom:1px solid rgb(14, 14, 14);">
        <div style="text-align: left;font-size: 25px;font-weight: bold;">筛查结果</div>
        <div style="display: table;width:100%;line-height: 80px;">
          <div style="display: table-cell; width:50%;text-align: center;font-size: 22px;font-weight: bold;"><span>左耳：</span><span>{{ model.hearing.leftEar ? model.hearing.leftEar : "" }}</span></div>
          <div style="display: table-cell; width:50%;text-align: center;font-size: 22px;font-weight: bold;"><span>右耳：</span><span>{{ model.hearing.rightEar ? model.hearing.rightEar : "" }}</span></div>
        </div>

        <table style="width: 80%;margin-left:10%;margin-top: 10px;margin-bottom: 50px;border-collapse: collapse;border:none;text-align: center;">
          <tbody>
          <tr style="background: #f8f9f9;line-height: 35px;"><td style="border-collapse: collapse;border:none;">项目名称</td><td style="border-collapse: collapse;border:none;">结果</td><td style="border-collapse: collapse;border:none;">参考值</td></tr>
          <tr style="line-height: 35px;"><td style="border-collapse: collapse;border:none;">刺激强度</td><td style="border-collapse: collapse;border:none;"><span>{{model.hearing.stimulsIntensity}}</span>dB</td><td style="border-collapse: collapse;border:none;">60dB~80dB</td></tr>
          <tr style="line-height: 35px;"><td style="border-collapse: collapse;border:none;">总反应能量</td><td style="border-collapse: collapse;border:none;"><span>{{model.hearing.totalReactionEnergy}}</span>dB</td><td style="border-collapse: collapse;border:none;">4.5~18.9dB</td></tr>
          <tr style="line-height: 35px;"><td style="border-collapse: collapse;border:none;">总相关度</td><td style="border-collapse: collapse;border:none;"><span>{{model.hearing.totalCorrelation}}</span>%</td><td style="border-collapse: collapse;border:none;">80%</td></tr>
          </tbody>
        </table>
      </div>

      <table style="margin-top: 10px;width: 100%;border-collapse: collapse;border:none;text-align: center;">
        <tbody>
          <tr style="text-align: left;">
            <td style="border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【筛查小结】</p></div>
              <div style="min-height: 20px;"><p>{{ model.hearing.result ? model.hearing.result : "" }}</p></div>
            </td>
          </tr>
          <tr style="text-align: left;" valign="top">
            <td style="border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【温馨提示】</p></div>
              <div style="min-height: 20px;"><p>{{ model.hearing.pointOut ? model.hearing.pointOut : "" }}</p></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>

import {_hearing} from "@/services/report/report";
export default {
  name: "hearingReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        hearing: {
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    }
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'hearing'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'hearing') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.hearing(this.barCode);
      }
    },
    hearing(barCode) {
      _hearing({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
      })
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .hearing-page {
    page: hearing-page; /* 绑定唯一命名 */
  }
  @page hearing-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:10px;padding-left:30px;padding-right:30px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}

</style>
